import React from "react";
import { v4 as uuid } from "uuid";

import { usePlayContext } from "../../pages/Play/play-context";
import styles from "./action-lines.module.scss";
import { useActionPath } from "./hooks";
import { ArrowMarker } from "./markers";
import { ActionLineProps } from "./types";

export interface ShootProps extends ActionLineProps {
  coverColor?: string;
}

export const Shoot = ({
  action,
  controlPoints,
  coverColor = "#fff",
  strokeWidth = 0.3,
  animateable = false,
}: ShootProps) => {
  const { color = "#000" } = action;
  const markerEndId = uuid();

  const { straightPathData, pathsWithScales, endTime } = useActionPath({ action, controlPoints });

  const { animationTimerApi } = usePlayContext();
  const { effectiveTime: time } = animationTimerApi;

  return (
    <>
      <ArrowMarker id={markerEndId} color={color} xOffset={7} />
      {pathsWithScales.map((path, i) => (
        <g key={i}>
          <path
            d={path.pathString}
            className={styles.actionLine}
            stroke={color}
            strokeWidth={strokeWidth * 3}
            fill="none"
            strokeDasharray={`10000 10000`}
            strokeDashoffset={animateable ? path.scale(time) : 0}
          />
          <path
            d={path.pathString}
            className={styles.actionLine}
            stroke={color}
            strokeWidth={strokeWidth * 3}
            fill="none"
            opacity={0.2}
          />
        </g>
      ))}
      <path
        d={straightPathData}
        className={styles.actionLine}
        markerEnd={`url(#arrow-${markerEndId})`}
        stroke={coverColor}
        strokeWidth={strokeWidth}
        fill="none"
        opacity={animateable && endTime && time >= endTime ? 0.2 : 1}
      />
    </>
  );
};
